import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-blocking-div',
  styleUrls: ['./blocking.component.scss'],
  template: '<div class="td-wb-content-overlay td-wb-content-overlay--button"></div>'
})
export class BlockingComponent {}
